const FROZEN = new Set(["signed", "approved", "counter_signed", "paid", "deposit_paid"]);

function parseValidUntil(raw) {
  if (!raw) return null;
  const s = String(raw).trim();
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return new Date(s.slice(0, 10) + "T12:00:00");
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function isQuoteExpired(quote) {
  if (!quote || FROZEN.has(quote.status)) return false;
  if (quote.customer_signature?.signature) return false;
  const d = parseValidUntil(quote.valid_until);
  if (!d) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d < today;
}
